import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import { PaymentTab } from 'projects/admin/src/app/models/exemptionFilling';
import { forkJoin } from 'rxjs';
import { ConfirmModalComponent } from '../../shared/component/confirm-modal/confirm-modal.component';
import { ExternalFilingRequestService } from '../../shared/services/exemptionFilingRequest';
import { ExternalCommonService } from '../../shared/services/external.common.service';
import { ExternalDocumentService } from '../../shared/services/externalDocument.service';

@Component({
  selector: 'app-exernal-payment-tab',
  templateUrl: './exernal-payment-tab.component.html',
  styleUrls: ['./exernal-payment-tab.component.scss'],
})
export class ExernalPaymentTabComponent implements OnInit {
  @Input()
  ParentForm!: FormGroup;
  @Input()
  PaymentUploadMode: any;
  @Input()
  isCorrectQualification = false;
  requestId: any;
  summary: any;
  data: any;
  constructor(
    private exemptionDocumentService: ExternalDocumentService,
    private dialog: MatDialog,
    private commonService: ExternalCommonService,
    private exemptionFilingRequestService: ExternalFilingRequestService,
    private routerService: Router,
    private router: ActivatedRoute
  ) {}

  async ngOnInit() {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.exemptionFilingRequestService
      .getSummary(this.requestId)
      .subscribe((res) => (this.summary = res));
    this.data = await this.exemptionFilingRequestService.getExemptionFilingRequestDetail(this.requestId).toPromise();;
  }

  onOnlinePayment() {
    this.routerService.navigate([
      'exemptionpaynow',
      btoa(this.requestId),
    ]);
    // this.exemptionDocumentService
    //   .getDocuments(this.requestId)
    //   .subscribe((res) => {
    //     if (res && res.length > 0) {
    //       this.routerService.navigate([
    //         'exemptionpaynow',
    //         btoa(this.requestId),
    //       ]);
    //     } else {
    //       if (this.data.paymentAndUploadMode == '1' || this.data.paymentAndUploadMode == '2') {
    //         let isDocRequired =  this.checkRequiredData();
    //         if (isDocRequired) {
    //           this.dialog.open(ConfirmModalComponent, {
    //             data: {
    //               title: 'Warning',
    //               warning: true,
    //               message: `Please attach all the required under upload tab to submit payment online. \n OR \n Click the Mail in button co continue `,
    //             },
    //             disableClose: true,
    //           });
    //         } else {
    //           this.routerService.navigate([
    //             'exemptionpaynow',
    //             btoa(this.requestId),
    //           ]);
    //         }
    //       } else {
    //         this.routerService.navigate([
    //           'exemptionpaynow',
    //           btoa(this.requestId),
    //         ]);
    //       }
    //     }
    //   });
  }

  checkRequiredData() {
    let isDocumentRequired = false;
    if (this.data?.exemptionRequestType?.code == 'INITIAL' || this.data?.exemptionRequestType?.code == 'SUBSEQUENT') {
      isDocumentRequired = true;
    }
    if ((this.data?.exemptionRequestType?.code == 'INITIAL' || this.data?.exemptionRequestType?.code == 'SUBSEQUENT') 
    && ( this.data?.qualificationType?.code == 'RELSECTBUSINESSENT' || this.data?.qualificationType?.code == 'RELSECTSOLEPROP' )) {
      isDocumentRequired = true;
    }
    if ((this.data?.exemptionRequestType?.code == 'INITIAL' || this.data?.exemptionRequestType?.code == 'SUBSEQUENT') 
    && (this.data?.qualificationType?.code == 'RELSECTBUSINESSENT' || this.data?.qualificationType?.code == 'RELSECTSOLEPROP' )) {
      isDocumentRequired = true;
    }
    if ((this.data?.exemptionRequestType?.code == 'RENEWAL' || this.data?.exemptionRequestType?.code == 'SUBRENEWAL'
    || this.data?.exemptionRequestType?.code == 'REINSTATE'|| this.data?.exemptionRequestType?.code == 'SUBREINSTATE'
    || this.data?.exemptionRequestType?.code == 'CORRECTION') 
    && ( this.data?.qualificationType?.code == 'RELSECTBUSINESSENT' || this.data?.qualificationType?.code == 'RELSECTSOLEPROP' )) {
      isDocumentRequired = true;
    }
    if (this.data?.exemptionRequestType?.code == 'CORRECTION' && this.isCorrectQualification) {
      isDocumentRequired = true;
    }
    if ((this.data?.exemptionRequestType?.code == 'CORRECTION') && this.isCorrectQualification
    && ( this.data?.qualificationType?.code == 'RELSECTBUSINESSENT' || this.data?.qualificationType?.code == 'RELSECTSOLEPROP' )) {
      isDocumentRequired = true;
    }
    return isDocumentRequired;
  }

  onMailinPayment() {
    console.log(this.requestId);

    forkJoin({
      reqT: this.commonService.getRequestStatusTypes(),
      externalT: this.commonService.getExternalStatusTypes(),
    }).subscribe(({ reqT, externalT }) => {
      const reqType = reqT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      const ereqType = externalT.find(
        (x: { code: string }) => x.code == 'PENDING'
      )?.id;
      this.exemptionFilingRequestService
        .updateRequestCopyStatus(this.requestId, ereqType, reqType)
        .subscribe((res) => {
          this.routerService.navigate([
            'mailedpaymentconfirmation',
            btoa(this.requestId),
          ]);
        });
    });
  }
}
